import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconRemoveFormatting = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M5.27 18.5l-4.22-4.222a1.03 1.03 0 010-1.453L11.217 2.658a1.03 1.03 0 011.453 0l5.447 5.447c.4.402.4 1.05 0 1.452L9.23 18.444M4.68 9.194l6.9 6.9M.75 21.498h4.5M12.75 21.498h1.5M17.25 21.498h1.5M21.75 21.498h1.5M8.25 21.498h1.5",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconRemoveFormatting.displayName = "IconRemoveFormatting";

export { IconRemoveFormatting };
